export default __webpack_public_path__ + "static/media/microsoftIcon.14d5cd00.svg";